import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecoBase-eco-loader',
  templateUrl: './eco-loader.component.html',
  styleUrls: ['./eco-loader.component.scss']
})
export class EcoLoaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
